module.exports = __webpack_public_path__ + "img/ampelourgia.abfd5f09.jpg";